export function getDayNameLocalized(nameOfDay: "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday", locale: string = "en") {
  const weekDays = {
    Monday: new Date(1970, 5, 1),
    Tuesday: new Date(1970, 5, 2),
    Wednesday: new Date(1970, 5, 3),
    Thursday: new Date(1970, 5, 4),
    Friday: new Date(1970, 5, 5),
    Saturday: new Date(1970, 5, 6),
    Sunday: new Date(1970, 5, 7),
  };

  const dayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
  const formatted = dayFormatter.format(weekDays[nameOfDay])
  const capitalized = formatted[0].toUpperCase() + formatted.substring(1);
  return capitalized.replace('.', '');
}
